<template>
    <div class="search container">
        <Table />
        <div class="search__block">
            <Bread :title1="'Главная'" :title2="'Поиск'" :link1="'/'"/>
            <div class="search__block__title">
                <p>Результаты поиска</p>
            </div>
            <div class="info__right__top__icons__search">
              <div class="info__right__top__icons__search__main">
                <input type="search" placeholder="Поиск" @keydown.enter="searchODIT" v-model="searchQuery">
                <button type="submit" @click="searchODIT"></button>
              </div>
            </div>
            <!-- <div class="search__block__results">
                <p>Поиск по запросу: 
                    <input type="search" placeholder="Поиск" @keydown.enter="searchODIT" v-model="searchQuery">
                </p>
                
            </div>
            
            <div class="search__block__results">
                <p>Поиск по запросу: <span style="color: #363636;">{{ this.$route.query.search }}</span></p>
            </div> -->
            <div class="search__block__count">
                <p>Найдено ({{ allDates.length }}) товара</p>
            </div>
            <div class="search__block__products" v-if="allDates.length > 0">
                <CardProduct :item="item" v-for="item in allDates" :key="item"/>
            </div>
            <div v-else>
                <p>Нет совпадений</p>
            </div>
        </div>
    </div>
</template>
<script>
import Table from '@/components/Table.vue';
import Bread from '@/components/Bread.vue';
import CardProduct from '@/components/CardProduct.vue';
import axios from 'axios';
import { toast } from 'vue3-toastify';
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';
import router from '@/router'
import { mapGetters } from 'vuex';
import 'vue3-toastify/dist/index.css';
import { onMounted, onBeforeUnmount } from 'vue';
export default {
    data(){
        return{
            allDates: []
        }
    },
    components: {
        Table, Bread, CardProduct
    },
    mounted() {
        if (this.$route.query.search) {
            this.searchQuery = this.$route.query.search;
            const searchData = localStorage.getItem("searchResult");
            if (searchData) {
                try {
                    this.allDates = JSON.parse(searchData);
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                }
            }
        }
    },
    methods: {
    goResult() {
      localStorage.setItem('searchResult', JSON.stringify(this.searchResults))
      this.$router.push({ name: 'allresults', query: { search: this.searchQuery } })
      setTimeout(() => {
        this.searchQuery = "",
        this.searchResults = []
      }, 300);
    },
    searchODIT() {
      const apiUrl = `https://admin.hayward.kz/api/V1/pages/products/search?text=${encodeURIComponent(this.searchQuery)}`;
      axios.get(apiUrl)
        .then(response => {
          // Сохраните результаты поиска в searchResults
          this.searchResults = response.data.products;
          this.goResult()
        })
        .catch(error => {
          // Обработайте возможные ошибки
          console.log(error);
          toast.error('Поле для поиска обязательно')
        });
    },
    },

    watch: {
        "$route.query"() {
            if (this.$route.query.search) {
                this.searchQuery = this.$route.query.search;
                const searchData = localStorage.getItem("searchResult");
                if (searchData) {
                    try {
                        this.allDates = JSON.parse(searchData);
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .search{
        display: flex;
        justify-content: space-between;
        padding-top: 25px;
        padding-bottom: 150px;
        &__block{
            width: 74.07%;
            display: flex;
            flex-direction: column;
            gap: 25px;
            &__title{
                font-size: 20px;
                font-weight: 600;
            }
            &__results{
                border: 1px solid #00000033;
                padding: 12px 15px;
                width: 70%;
                border-radius: 10px;
                color: #00000080;
                input {
                    border: 0px;
                    font-size: 18px;
                    color: #363636;
                    outline: none;
                   // padding: 12px 15px;
                    // padding: 5px min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px) 5px 10px;
                    // width: max-content;
                    }
                button {
                    display: inline-block;
                    // top: 50%;
                    // padding-bottom: 10px;
                    margin-left: 10px;
                    //transform: translateY(-50%);
                    width: 20px;
                    /* Установите ширину и высоту кнопки по вашему желанию */
                    height: 20px;
                    background: url('@/assets/icons/search.svg') no-repeat center center;
                    /* Укажите путь к вашей картинке */
                    background-size: contain;
                    /* Размер изображения */
                    border: none;
                
                    cursor: pointer;
                }
            }
            &__count{
                color: #006495;
            }
            &__products{
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
                gap: 60px;
                row-gap: 50px;
            }
        }
    }
.info {
  display: flex;
  justify-content: space-between;
  padding-top: min(max(30px, calc(1.875rem + ((1vw - 7.68px) * 2.6042))), 60px);
  align-items: center;
  &__left {
    width: 22.63%;
    font-size: 42px;
    img{
      width: 100%;
    }
  }
  &__right {
    width: 74.07%;
    display: flex;
    flex-direction: column;
    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 1.3021))), 30px);
    &__top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      &__texts {
        display: flex;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 1.3021))), 30px);
        color: #363636;
        font-size: 20px;
      }
      &__icons {
        display: flex;
        gap: min(max(17px, calc(1.0625rem + ((1vw - 7.68px) * 1.5625))), 35px);
        align-items: center;
        &__search {
          position: relative;
          input {
            border: 1px solid #00000033;
            font-size: 20px;
            border-radius: 10px;
            outline: none;
            padding: 12px 15px;
            // padding: 5px min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px) 5px 10px;
            width: auto;
          }
          button {
            // position: absolute;
            // top: 50%;
            padding-bottom: 10px;
            margin-left: 10px;
            transform: translateY(-50%);
            width: 20px;
            /* Установите ширину и высоту кнопки по вашему желанию */
            height: 20px;
            background: url('@/assets/icons/search.svg') no-repeat center center;
            /* Укажите путь к вашей картинке */
            background-size: contain;
            /* Размер изображения */
            border: none;
           
            cursor: pointer;
          }
          &__block {
            position: absolute;
            border: 1px solid #00000033;
            width: 100%;
            top: 150%;
            border-radius: 10px;
            padding: 5px min(max(5px, calc(0.3125rem + ((1vw - 0.07px) * 62.5))), 10px);
            z-index: 999;
            background: white;
          }
        }
      }
    }
  }
}
</style>